import { schedulerSlice } from "./reducer";

export const {
  addDeviceToNotify,
  addTask,
  changeEnabled,
  changeNotifyAllDevices,
  removeDeviceToNotify,
  removeTask,
  updateTask
} = schedulerSlice.actions;
